<template>
    <div id="dashboard-view">
        <teleport to="#sub-nav">
            <!-- <div class="button" @click="updateLogs">{{fetching_logs ? 'PLEASE BE PATIENT' : 'Pull Logs'}}</div> -->
            <div class="button" @click="fetchAllPlayers">{{fetching_players ? 'FETCHING.. THIS TAKES LONG TIME' : 'Reindex'}}</div>
            <div class="button" @click="calculatePlayerStats">{{calculating_interactions ? 'CALCULATING..' : 'Update Interactions'}}</div>
            
            <div class="filter-item">
                <label for="sort-by-input">Sort By </label>
                <select v-model="sort_by" id="sort-by-input">
                    <option value="interactions" default>Total Interactions</option>
                    
                    <option 
                        v-for="field in sort_by_fields" 
                        :key="`sort-by-option-${field}`"
                        :value="field"
                    >
                        {{field}}
                    </option>
                </select>
                <select v-model="sort_by_dir" id="sort-by-dir-input">   
                    <option default value="desc">Descending</option>
                    <option default value="asc">Ascending</option>
                </select>
                <input type="text" v-model="player_search" placeholder="search"/>
            </div>
        </teleport>

        

        <recycle-scroller id="player-scroller" :items="players_array" :item-size="70" key-field="id" v-slot="{item}">
            <div v-if="item" class="player-row">
                <div class="left">
                    <div class="top">
                        <span class="cell" @click="setSortBy('id')">
                            <a :href="`https://www.torn.com/profiles.php?XID=${item.id}`">[{{item.id}}]</a>
                        </span> 
                        <span class="cell" @click="setSortBy('name')">
                            <router-link :to="`/players/${item.id}`">{{item.name}}</router-link>
                        </span>

                        <span class="cell" @click="setSortBy('level')">
                            Level {{item.level}}
                        </span>
                        
                        <span class="cell" @click="setSortBy('rank')">
                            {{item.rank}}, 
                        </span>

                        <span class="cell" @click="setSortBy('age')">
                            Age {{item.age}}
                        </span>
                    </div>
                    <div class="middle">
                        <span class="cell" @click="setSortBy('friends')">
                            {{item.friends}} Friends, 
                        </span>

                        <span class="cell" @click="setSortBy('enemies')">
                            {{item.enemies}} Enemies - 
                        </span>

                        <span class="cell">
                            {{item.donator ? 'Subscriber' : 'Non-Subscriber'}}
                        </span>
                    </div>
                </div>
                <div class="right">
                    <div v-if="item.total_interactions" class="interaction-badge" @click="setSortBy('interactions')">
                        Interactions: {{item.total_interactions}}
                    </div>
                    <template v-if="item.interactions">
                        <div class="interaction-badge" v-for="interaction in item.interactions" :key="`player-${item.id}-interaction-${interaction.name}`" @click="setSortBy(interaction.name)">
                            {{interaction.name}}: {{interaction.logs.length}}
                        </div>
                    </template>

                </div>
                <!-- <div>
                </div> -->
            </div>
        </recycle-scroller>
    </div>
</template>

<script>

import {INTERACTION_FIELDS} from '../constants/players';
const PLAYER_FIELDS = [
    'id',
    'name',
    'level',
    'rank',
    'age',
    'friends',
    'enemies'
];

export default {
    name: 'Players',
    data() {
        return {
            sort_by: 'interactions',
            sort_by_dir: 'desc',
            player_search: null,
            sort_by_fields: [
                ...INTERACTION_FIELDS.map(field => {
                    let first_char = field[0];
                    let rest = field.slice(1)
                    return `${first_char.toUpperCase()}${rest}`;
                }),
                ...PLAYER_FIELDS.map(field => {
                    let first_char = field[0];
                    let rest = field.slice(1)
                    return `${first_char.toUpperCase()}${rest}`;
                })
            ]
        }
    },
    components: {
        // RecycleScroller
    },
    methods: {
       
        fetchAllPlayers() {
            this.$store.dispatch('fetchMissingPlayers');
        },

        calculatePlayerStats() {
            this.$store.dispatch('calculatePlayerStats');
        },
        
        async fetchBrokenPlayers() {
            let player_ids = await database.players.orderBy('id').toArray();
            player_ids=player_ids.filter(player => {
                return player.error
            }).map(player => player.id);

            let players_to_delete = player_ids.filter(id => id < 0);
            for (let id of players_to_delete) {
                database.players.delete(id);
            }

            let players_to_fetch = player_ids.filter(id => id > 0);

            // console.log("PLAYErS", player_ids);
            this.$store.dispatch('fetchPlayers', players_to_fetch);
        },

        renderData(data) {
            if (isNaN(data) || !data && data !== 0) return data;
            else if (Math.ceil(data) == data) return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            else return parseFloat(data).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        setSortBy(field) {
            if (this.sort_by === field) {
                this.sort_by_dir = this.sort_by_dir === 'asc' ? 'desc' : 'asc';
            } else this.sort_by = field;
        },

        sortPlayers(a, b) {
            let sign = this.sort_by_dir === 'desc' ? -1 : 1;
            let should_parse = true;
            let sort_by = this.sort_by.toLowerCase();
            switch (sort_by) {
                case 'interactions': {
                    if (!a.total_interactions && b.total_interactions) return -1 * sign;
                    else if (!a.total_interactions && !b.total_interactions) return 0;
                    else if (!b.total_interactions) return 1 * sign;

                    else if (a.total_interactions < b.total_interactions) return -1 * sign;
                    else if (a.total_interactions > b.total_interactions) return 1 *sign;
                    else return 0;
                }

                case 'name':
                case 'rank': {
                    should_parse = false;
                }
                case 'id': 
                case 'level': 
                case 'age': 
                case 'friends': 
                case 'enemies': 
                    let av = should_parse ? parseFloat(a[sort_by]) : a[sort_by];
                    let bv = should_parse ? parseFloat(b[sort_by]) : b[sort_by];

                    if (!av && bv) return -1 * sign;
                    else if (!av && !bv) return 0;
                    else if (!bv)  return  1 * sign;

                    else if (av < bv) return -1 * sign;
                    else if (av > bv) return  1 * sign;
                    else return 0;
                

                default: {
                    let av = a.interactions.find(interaction => interaction.name === sort_by)?.logs.length || 0;
                    let bv = b.interactions.find(interaction => interaction.name === sort_by)?.logs.length || 0;

                    if (!av && bv) return -1 * sign;
                    else if (!av && !bv) return 0;
                    else if (!bv)  return  1 * sign;

                    else if (av < bv) return -1 * sign;
                    else if (av > bv) return  1 * sign;
                    else return 0;
                }
            }
        }
    },
    
    computed: {
        auth_key() {
            return this.$store.state.auth.key;
        },

        players() {
            return this.$store.state.players;
        },

        players_array() {
            if (!this.players) return [];

            let players =  Object.values(this.players).filter(player => {
                let value =  player && player.id > 0 && player.role !== 'NPC';
                if (value && this.player_search) {
                    value = `${player.id}`.includes(this.player_search) || player?.name?.toLowerCase()?.includes(this.player_search.toLowerCase());
                }
                return value;

            });
            

            players = players.sort(this.sortPlayers);

            return players.slice(0, 250);
        },

        database() {
            return this.$store.getters.database;
        },

        fetching_logs() {
            return this.$store.state.sync.fetching_logs
        },

        fetching_players() {
            return this.$store.state.sync.fetching_players;
        },

        calculating_interactions() {
            return this.$store.state.sync.calculating_interactions;
        }
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$store.dispatch('getPlayers');
        })
    }
}
</script>
<style lang="scss">
    #dashboard-view {
        background-color: black;
    }

    #key-input-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    #player-scroller {
        min-height: 500px;
        width: 100%;
        height: 100vh;
    }

    #player-header {
        width: 100%;
        background-color: black;
    }

    .player-row {
        background-color: #3d3d3d;
        height: 65px;
        margin-bottom: 5px;
        padding: 10px;

        display: flex;

        // .left {
        //     // flex: 1;
        //     min-width: 300px;
        // }

        // .right {
        //     flex: 1;
        // }



        .left > div {
            display: flex;
            align-items: center;
        }

        .cell {
            margin-right: 8px;

            .key {
                font-size: 0.8rem;
                font-weight: bold;
            }
        }

        &:nth-child(even) {
            background-color: #4d4d4d;
        }
    }

    .interaction-badge {
        background-color: black;
        color: white;
        border-radius: 5px;
        margin-right: 5px;
        padding: 5px;
        font-size: 11px;
        text-transform: capitalize;
        display: inline-block;
    }

</style>